import React from 'react'
import { PieChart, Pie, Tooltip, Legend, ResponsiveContainer, Cell } from "recharts";

const PieCharts = ({ data, nameKey, title, innerRadius, colors, colorMap, dataKey = "value", onBarClick }) => {
    const renderLegendText = (value, entry) => {
        return (
            <span style={{ color: "#333", wordWrap: 'break-word', whiteSpace: 'normal', display: 'inline-block', maxWidth: '180px', verticalAlign: 'top', paddingLeft: '4px' }}>
                {value}
            </span>
        );
    };

    return (
        <div className='w-full h-full flex flex-col'>
            <h1 className='font-semibold mb-8 ml-2'>{title}</h1>
            <div style={{ width: "100%", height: 300 }} className="flex-1 min-h-0">
                <ResponsiveContainer>
                    <PieChart >
                        <Pie
                            data={data}
                            dataKey={dataKey}
                            nameKey={nameKey}
                            outerRadius="75%"
                            innerRadius={innerRadius}
                            onClick={(data) => onBarClick?.(data)}
                            label={({ value, x, y, cx, fill }) => (
                                <text
                                    x={x}
                                    y={y}
                                    fill={fill}
                                    fontSize={13}
                                    textAnchor={x > cx ? 'start' : 'end'}
                                    dominantBaseline="central"
                                >
                                    {value}
                                </text>
                            )}
                        >
                            {data.map((entry, index) => (
                                <Cell
                                    key={`cell-${index}`}
                                    fill={colorMap && colorMap[entry[nameKey]] ? colorMap[entry[nameKey]] : colors[index % colors.length]}
                                />
                            ))}
                        </Pie>

                        <Tooltip />
                        <Legend
                            formatter={renderLegendText}
                            wrapperStyle={{ fontSize: "13px", paddingTop: "10px", maxHeight: "150px", overflowY: "auto" }}
                            layout="horizontal"
                            verticalAlign="bottom"
                            align="center"
                        />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </div>
    )
}

export default PieCharts
